import * as React from 'react';
import { Link } from 'react-router-dom';
//import { createBrowserHistory } from 'history';

import actionTypes from '../../../../actions/ActionTypes';
import DefaultsSidebar from './DefaultsSidebar2';
import DefaultStore from '../../../../stores/DefaultsStore';
import { LoadDefault,
  UpdateDefault,
  LoadDefaults,
  DeleteDefault,
  SaveAsDefault,
 } from '../../../../actions/DefaultActions';
import { LoadReaders } from '../../../../actions/ReadersActions';
import AutoComplete from '../../../../components/AutoComplete';
import { GetBPList } from '../../../../actions/BPActions';
import BPStore from '../../../../stores/BPStore';
import { GetTemplateList } from '../../../../actions/TemplateActions';
import TemplateStore from '../../../../stores/TemplateStore';
import { GetFieldsByFormType } from '../../../../actions/InboxActions';
import InboxStore from '../../../../stores/InboxStore';
import ReadersStore from '../../../../stores/ReadersStore';


//const customHistory = createBrowserHistory();

class DefaultView extends React.Component {
  constructor(props) {
    super(props);
    // state
    this.state = {
      currentDefault: undefined,
      gotoDefault: 0,
      showEditName: false,
      editName: '',
      addNewAfterSave: false,
      isDirty: false,
      newMode: false,
      deleteConfirm: false,
      allBPs: [],
      selectedBP: undefined,
      selectedTemplate: undefined,
      selectedFT: '',
      selectedSplitMethod: undefined,
      selectedSplitField: undefined,
      selectedReader: undefined,
      allTemplates: [],
      filteredTemplates: [],
      allFields: [],
      showSaveAs: false,
      showSaveAsButton: false,
      saveAsName: '',
      allReaders: [
        {
          readerId: -1,
          readerName: 'No Reader'
        }
      ],
      allSplitMethods: [
        {
          method: 'NONE',
          desc: 'No Split'
        },
        {
          method: 'PAGE',
          desc: 'Split by Page #'
        },
        {
          method: 'FIELD',
          desc: 'Split by Field'
        },
        {
          method: 'TEMPLATE',
          desc: 'Split using Template'
        }
      ]
    };

    this.onDefaultChange = this.onDefaultChange.bind(this);
    this.onBPChange = this.onBPChange.bind(this);
    this.onInboxChange = this.onInboxChange.bind(this);
    this.editDefaultName = this.editDefaultName.bind(this);
    this.addIdClick = this.addIdClick.bind(this);
    this.onEditIdentifier = this.onEditIdentifier.bind(this);
    this.editIsRequired = this.editIsRequired.bind(this);
    this.update = this.update.bind(this);
    this.showDeleteConfirm = this.showDeleteConfirm.bind(this);
    this.deleteDefault = this.deleteDefault.bind(this);
    this.cancelDelete = this.cancelDelete.bind(this);
    this.updateDefault = this.updateDefault.bind(this);
    this.removeIdentifer = this.removeIdentifer.bind(this);
    this.selectBP = this.selectBP.bind(this);
    this.editFormType = this.editFormType.bind(this);
    this.onTemplateChange = this.onTemplateChange.bind(this);
    this.changeTemplate = this.changeTemplate.bind(this);
    this.selectReader = this.selectReader.bind(this);
    this.selectSplitMethod = this.selectSplitMethod.bind(this);
    this.selectSplitField = this.selectSplitField.bind(this);
    this.onEditDefaultValue = this.onEditDefaultValue.bind(this);
    this.selectDefaultValueField = this.selectDefaultValueField.bind(this);
    this.addDefaultValueClick = this.addDefaultValueClick.bind(this);
    this.removeDefaultValue = this.removeDefaultValue.bind(this);
    this.readersChange = this.readersChange.bind(this);
    this.saveAs = this.saveAs.bind(this);
    this.cancelSaveAs = this.cancelSaveAs.bind(this);
    this.editSaveAsName = this.editSaveAsName.bind(this);
    this.saveAsUpdate = this.saveAsUpdate.bind(this);
  }

  componentDidMount() {
    DefaultStore.addChangeListener(this.onDefaultChange);
    BPStore.addChangeListener(this.onBPChange);
    TemplateStore.addChangeListener(this.onTemplateChange);
    InboxStore.addChangeListener(this.onInboxChange);
    ReadersStore.addChangeListener(this.readersChange);
    this.checkForUpdate();
    LoadReaders();
    document.title = 'TrinDocs - Defaults'
  }

  componentWillUnmount() {
    DefaultStore.removeChangeListener(this.onDefaultChange);
    BPStore.removeChangeListener(this.onBPChange);
    TemplateStore.removeChangeListener(this.onTemplateChange);
    InboxStore.removeChangeListener(this.onInboxChange);
    ReadersStore.removeChangeListener(this.readersChange);
  }

  componentDidUpdate() {
    this.checkForUpdate();
  }

  readersChange() {
    let lastAction = ReadersStore.getLastAction();
    if (lastAction === actionTypes.GetReaders)
    {
      let readers = ReadersStore.getReaders();
      if(readers !== undefined)
      {
        let newAllReaders = [{
          readerId: -1,
          name: 'No Reader'
        }];
        readers.forEach(r => {
          newAllReaders.push(r);
        })
        this.setState({allReaders: newAllReaders});
      }
    }
  }

  onDefaultChange() {
    let lastAction = DefaultStore.getLastAction();
    if (lastAction === actionTypes.GetDefault) {
        let defaults = DefaultStore.getDefault();

        if(defaults !== undefined)
        {
            this.setState({currentDefault: defaults});

            if(defaults.defaultValues.length === 0)
            {
              this.addDefaultValueClick();
            }
            if(defaults.identifiers.length === 0)
            {
              this.addIdClick();
            }

            GetBPList();
            GetTemplateList();
            GetFieldsByFormType(defaults.formTypeId);
            this.setState({selectedReader: parseInt(defaults.readerId, 10)});
            this.setState({selectedSplitMethod: defaults.pageSplitMethod, newMode: false});
            this.setState({selectedSplitField: defaults.pageSplitFieldId, newMode: false});
        }
    }
    if (lastAction === actionTypes.DefaultSaveAs) {
      console.log('SaveAs post');
      let defaults = DefaultStore.getDefault();
      console.log(defaults);

      if(defaults !== undefined)
      {
        this.setState({showSaveAs: false});
          this.setState({currentDefault: defaults});
          this.setState({gotoDefault: defaults.defaultsDBId}, () => {
            let link = document.getElementById('loadDefaultLink');
            link.click();
          });
          if(defaults.defaultValues.length === 0)
          {
            this.addDefaultValueClick();
          }
          if(defaults.identifiers.length === 0)
          {
            this.addIdClick();
          }

          GetBPList();
          GetTemplateList();
          GetFieldsByFormType(defaults.formTypeId);
          this.setState({selectedReader: parseInt(defaults.readerId, 10)});
          this.setState({selectedSplitMethod: defaults.pageSplitMethod, newMode: false});
          this.setState({selectedSplitField: defaults.pageSplitFieldId, newMode: false});
      }
    }
    if (lastAction === actionTypes.DefaultUpdate) {
      let defaults = DefaultStore.getDefault();
      if(this.state.addNewAfterSave){
        this.setState({gotoDefault: 'new'}, () => {
          let link = document.getElementById('loadDefaultLink');
          link.click();
        });
      } else if(defaults !== undefined)
      {

        if(this.state.newMode === true) {
          LoadDefaults();
          this.setState({gotoDefault: defaults.defaultsDBId}, () => {
            let link = document.getElementById('loadDefaultLink');
            link.click();
          });
        } else {
          LoadDefaults();
          this.setState({currentDefault: defaults});
          GetBPList();
          GetTemplateList();
          GetFieldsByFormType(defaults.formTypeId);
          this.setState({selectedReader: parseInt(defaults.readerId, 10)});
          this.setState({selectedSplitMethod: defaults.pageSplitMethod});
        }
      }
    }
    if (lastAction === actionTypes.DefaultDelete) {
      let result = DefaultStore.getDeleteResult();
      if(result.resultStatus === 'Success')
      {
        let link = document.getElementById('defaultHome');
        link.click();
      }
      if(result.resultStatus === 'Error')
      {

      }

    }
  }

  onBPChange() {
    let lastAction = BPStore.getLastChange();
    if(lastAction === actionTypes.BPGetList)
    {
      let bps = BPStore.getBPList();
      if(this.state.currentDefault.businessProcessId !== undefined) {
        let idx = bps.find(bp => bp.bpId === this.state.currentDefault.businessProcessId);

        this.setState({allBPs: bps, selectedBP: idx.bpId, selectedFT: idx.formTypeName});
      }
      else {
        this.setState({allBPs: bps});
      }
    }
  }

  onTemplateChange() {
    let lastAction = TemplateStore.getLastChange();

    if(lastAction === actionTypes.TemplateList)
    {
      let allTemplates = TemplateStore.getTemplateList();
      console.log(allTemplates);
      allTemplates.forEach(tg => {
        tg.templates.push({
          templateId: -2,
          formTypeId: tg.formTypeId,
          name: 'No Template',
          isActive: true,
        });
        tg.templates.push({
          templateId: -1,
          formTypeId: tg.formTypeId,
          name: 'Smart Template Matching',
          isActive: true,
        });
      });
      this.setState({allTemplates: allTemplates});
      let ftId = parseInt(this.state.currentDefault.formTypeId);
      let templateGroup = allTemplates.find(tg => tg.formTypeId === ftId);
      if(templateGroup !== undefined)
      {
        console.log(templateGroup);
        let filter = [];
        templateGroup.templates.forEach((t) => {
          if(t.isActive)
          {
            filter.push(t);
          }
        });

        let selectTemplate = parseInt(this.state.currentDefault.templateId, 10);
        this.setState({filteredTemplates: filter, selectedTemplate: selectTemplate});
      } else {
        let tg = [];
        tg.push({
          templateId: -2,
          formTypeId: tg.formTypeId,
          name: 'No Template',
          isActive: true,
        });
        tg.push({
          templateId: -1,
          formTypeId: tg.formTypeId,
          name: 'Smart Template Matching',
          isActive: true,
        });
        let selectTemplate = parseInt(this.state.currentDefault.templateId, 10);
        this.setState({filteredTemplates: tg, selectedTemplate: selectTemplate});

      }
    }


  }

  checkForUpdate() {
    let loc = window.location.pathname;
    let pathParts = loc.split('/');
    let defaultId = pathParts[pathParts.length - 1];
    let defaultIdInt = parseInt(pathParts[pathParts.length - 1], 10);
    if (
      defaultId === 'new' &&
      this.state.newMode !== true
    ) {
      this.updateDefault();
    }
    if (defaultId !== 'new' &&
      this.state.currentDefault !== undefined &&
      parseInt(this.state.currentDefault.defaultsDBId, 10) !== defaultIdInt
    ){
      this.updateDefault();
    }
    if (defaultId !== 'new' &&
      this.state.currentDefault === undefined &&
      defaultIdInt > 0
    ){
      this.updateDefault();
    }
  }

  editDefaultName(e) {
    let r = this.state.currentDefault;
    if(e.target.value.length <= 40)
    {
      r.defaultName = e.target.value;
      this.setState({ currentDefault: r, isDirty: true });
    }
  }

  addIdClick() {
    let current = this.state.currentDefault;
    let newId = -1;
    current.identifiers.forEach(x => {
      if(x.dbIdentifierId <= newId) {
        newId = x.dbIdentifierId - 1;
      }
    })
    let newIdentifier = {
      identifier: '',
      dbIdentifierId: newId,
      isRequired: true,
    }
    current.identifiers.push(newIdentifier);
    this.setState({currentDefault: current, isDirty: true}, () => {

      let dom = document.getElementById(`identifier${newId.toString()}`);
      if(dom) { dom.focus(); }
    });
  }

  update(addNew) {
    let cd = this.state.currentDefault;
    cd.businessProcessId = this.state.selectedBP;
    cd.pageSplitMethod = this.state.selectedSplitMethod;
    cd.readerId = this.state.selectedReader;
    cd.templateId = this.state.selectedTemplate;
    cd.pageSplitFieldId = this.state.selectedSplitField;
    this.setState({addNewAfterSave: addNew});

    UpdateDefault(cd);
  }

  showDeleteConfirm() {
    this.setState({deleteConfirm: true});
  }

  deleteDefault() {
    DeleteDefault(this.state.currentDefault);
  }

  cancelDelete() {
    this.setState({deleteConfirm: false});
  }

  updateDefault() {
    let loc = window.location.pathname;
    let pathParts = loc.split('/');
    if(pathParts[pathParts.length - 1] === 'new')
    {
      let newDefault = {
        defaultDBId: -1,
        defaultName: '',
        identifiers: [],
      }
      GetBPList();
      this.setState({newMode: true, selectedBP: 0, currentDefault: newDefault},() => {
        let dom = document.getElementById('inputName');
        dom.focus();
      });

    } else {
      //this.setState({newMode: false});
      let defaultId = parseInt(pathParts[pathParts.length - 1], 10);
      LoadDefault(defaultId);
    }
  }

  editIsRequired(e, ident)
  {
    var current = this.state.currentDefault;
    ident.isRequired = e.target.checked;
    this.setState({currentDefault: current, isDirty: true});
  }

  onEditIdentifier(e, ident)
  {
    var current = this.state.currentDefault;
    ident.identifier = e.target.value;
    this.setState({currentDefault: current, isDirty: true});
  }

  removeIdentifer(ident)
  {
    var current = this.state.currentDefault;
    var idents = current.identifiers;
    var idx = idents.indexOf(ident);
    if(idx >= 0) {
      idents.splice(idx, 1);
    }
    this.setState({currentDefault: current, isDirty: true});
  }

  selectBP(e) {
    let current = this.state.currentDefault;
    let bp = this.state.allBPs.find(b => b.bpId === e);
    current.businessProcessId = e;
    this.setState({currentDefault: current, selectedBP: e, selectedFT: bp.formTypeName, isDirty: true});

    GetFieldsByFormType(bp.formTypeId);
    // is my template id still valid?
    let tg = this.state.allTemplates.find(t => t.formTypeId === bp.formTypeId);
    if(tg === undefined)
    {
      let templateList = [];
      templateList.push({
        templateId: -2,
        formTypeId: bp.formTypeId,
        name: 'No Template',
        isActive: true,
      });
      templateList.push({
        templateId: -1,
        formTypeId: bp.formTypeId,
        name: 'Smart Template Matching',
        isActive: true,
      });
      this.setState({filteredTemplates: templateList, selectedTemplate: -1});
    } else {
      console.log(tg.templates);
      let filter = [];
      tg.templates.forEach((t) => {
        if(t.isActive) {
          filter.push(t);
        }
      });
      this.setState({filteredTemplates: filter});
      let tempChoice = tg.templates.find(t => t.templateId === this.state.selectedTemplate);
      if(tempChoice === undefined)
      {
        this.setState({selectedTemplate: -1});
      }
    }

  }

  editFormType(){

  }

  changeTemplate(e) {
    this.setState({selectedTemplate: e, isDirty: true});
  }

  selectReader(e) {
    this.setState({selectedReader: e, isDirty: true});
  }

  selectSplitMethod(e) {
    this.setState({selectedSplitMethod: e, isDirty: true});
  }

  onInboxChange() {
    let lastAction = InboxStore.lastChange();
    if(lastAction === actionTypes.GetFieldsByFormType)
    {
      let _fields = InboxStore.getFields();
      this.setState({allFields: _fields});
    }
  }

  selectSplitField(e) {
    this.setState({selectedSplitField: e, isDirty: true});
  }

  onEditDefaultValue(e, dv)
  {
    let cd = this.state.currentDefault;
    dv.defaultValue = e.target.value;
    this.setState({currentDefault: cd, isDirty: true});
  }

  selectDefaultValueField(e, dv)
  {
    let cd = this.state.currentDefault;

    dv.fieldId = e;
    this.setState({currentDefault: cd, isDirty: true});
  }

  addDefaultValueClick() {
    let current = this.state.currentDefault;
    let newId = -1;
    current.defaultValues.forEach(x => {
      if(x.dbDefaultValueId <= newId) {
        newId = x.dbDefaultValueId - 1;
      }
    })
    let newDefault = {
      defaultValue: '',
      dbDefaultValueId: newId,
      fieldId: 0
    }
    current.defaultValues.push(newDefault);
    this.setState({currentDefault: current, isDirty: true});
  }

  removeDefaultValue(dv)
  {
    let current = this.state.currentDefault;
    var dvs = current.defaultValues;
    var idx = dvs.indexOf(dv);
    if(idx >= 0) {
      dvs.splice(idx, 1);
    }
    this.setState({currentDefault: current, isDirty: true});
  }

  saveAs()
  {
    this.setState({showSaveAs: true});
  }

  cancelSaveAs()
  {
    this.setState({showSaveAs: false});
  }

  editSaveAsName(e) {
    let name = e.target.value;
    this.setState({saveAsName: name});
    if(name.length < 3)
    {
      this.setState({showSaveAsButton: false});
    } else if(name.toUpperCase() === this.state.currentDefault.defaultName.toUpperCase())
    {
      this.setState({showSaveAsButton: false});
    } else
    {
      this.setState({showSaveAsButton: true});
    }
  }

  saveAsUpdate() {
    console.log(this.state.currentDefault);
    console.log('Save as');
    let cd = this.state.currentDefault;
    cd.defaultName = this.state.saveAsName;
    cd.businessProcessId = this.state.selectedBP;
    cd.pageSplitMethod = this.state.selectedSplitMethod;
    cd.readerId = this.state.selectedReader;
    cd.templateId = this.state.selectedTemplate;
    cd.pageSplitFieldId = this.state.selectedSplitField;

    SaveAsDefault(cd);
  }




  render() {
    return (
      <div className='container-fluid' style={{ height: '100%' }}>
        <div className='row flex-nowrap' style={{ height: '100%' }}>
          <DefaultsSidebar />
          {this.state.currentDefault !== undefined && (
            <div
              className='flex-fill'
              style={{ backgroundColor: '#efefef', padding: '15px' }}
            >
              <div
                className='card'
                style={{
                  marginTop: '5px',
                }}
              >
                <div className='card-header'><h4 style={{float:'left'}}>Default</h4>

                </div>
                <div className='card-body mb-2' style={{paddingRight:'6px'}}>
                  <div className='col-6'>
                    <label>Name:</label>
                    <input
                      type='text'
                      id='inputName'
                      autoComplete='off'
                      className='form-control'
                      value={this.state.currentDefault.defaultName}
                      onChange={this.editDefaultName}
                    ></input>
                    {this.state.newMode === true &&
                      <div>
                        <div className='row mb-3'>
                      <div className='col mt-2'>
                        <div>Default Business Process</div>
                        {this.state.selectedBP !== undefined &&
                          <AutoComplete
                            id={`acBusinessProcess`}
                            allowedValues={this.state.allBPs}
                            value={this.state.selectedBP}
                            valueField='bpId'
                            displayField='bpName'
                            onChange={this.selectBP}
                            //setFocus={this.setCurrentRoute}
                          />
                        }
                      </div>


                      </div>
                      <button className='btn btn-success' onClick={() => this.update(false)}><i  className='fa-solid fa-square-plus' />{' '}Create</button>
                      </div>
                    }
                  </div>
                {this.state.newMode === false &&
                  <div className='mt-4'>

                    <div className='row mb-4'>
                      <div className='col-6'>
                        <h5>Settings</h5>
                        <table className='ms-4' >
                          <tbody>
                          {this.state.selectedBP !== undefined &&
                            <tr>
                              <td className='pe-2'>Default Business Process:</td>
                              <td>
                                <AutoComplete
                                  id={`acBusinessProcess`}
                                  allowedValues={this.state.allBPs}
                                  value={this.state.selectedBP}
                                  valueField='bpId'
                                  displayField='bpName'
                                  onChange={this.selectBP}
                                  //setFocus={this.setCurrentRoute}
                                />

                              </td>
                            </tr>
                          }
                          {this.state.selectedBP !== undefined &&
                            <tr>
                              <td className='me-2'>Default FormType:</td>
                              <td>
                                <input type="text" autoComplete='off' className='form-control' value={this.state.selectedFT} readOnly onChange={this.editFormType}  />
                              </td>
                            </tr>
                          }
                          <tr>
                            <td className='me-2'>Default Reader:</td>
                            <td>
                              <AutoComplete
                              id={`acReader`}
                              allowedValues={this.state.allReaders}
                              value={this.state.selectedReader}
                              valueField='readerId'
                              displayField='name'
                              onChange={this.selectReader}
                              //setFocus={this.setCurrentRoute}
                            />

                            </td>
                          </tr>
                          <tr>
                            <td className='me-2'>Default Template:</td>
                            <td>
                              <AutoComplete
                              id={`acTemplate`}
                              allowedValues={this.state.filteredTemplates}
                              value={this.state.selectedTemplate}
                              valueField='templateId'
                              displayField='name'
                              onChange={this.changeTemplate}
                              //setFocus={this.setCurrentRoute}
                            />
                            </td>
                          </tr>

                          <tr>
                            <td className='me-2'>Page Split Method:</td>
                            <td>
                              <AutoComplete
                              id={`acPageSplitMethod`}
                              allowedValues={this.state.allSplitMethods}
                              value={this.state.selectedSplitMethod}
                              valueField='method'
                              displayField='desc'
                              onChange={this.selectSplitMethod}
                              //setFocus={this.setCurrentRoute}
                            />

                            </td>
                          </tr>
                          {this.state.selectedSplitMethod === 'FIELD' &&
                            <tr>
                              <td className='me-2'>Page Split Field:</td>
                              <td>
                                <AutoComplete
                                id={`acPageSplitField`}
                                allowedValues={this.state.allFields}
                                value={this.state.selectedSplitField}
                                valueField='fieldId'
                                displayField='name'
                                onChange={this.selectSplitField}
                                />
                              </td>
                            </tr>
                          }
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div className='mb-4'>
                      <h5>Identifiers:</h5>
                      <div>
                      <div className="row ms-2">
                        <div className="col-6 mb-2">
                    {this.state.currentDefault.identifiers.map((ident) => (
                      ident.isDeleted !== true &&
                        <div key={ident.dbIdentifierId} >

                          <div className='input-group mb-2'>
                            <div className="input-group-prepend">
                              <div className="input-group-text">
                                <input className="form-check-input" type="checkbox" checked={ident.isRequired} onChange={(e) => this.editIsRequired(e, ident)} />
                                <label className="form-check-label ms-2">{ident.isRequired ? 'Required' : 'Optional'}</label>
                              </div>
                            </div>
                            <input type="text" className="form-control" autoComplete='off' id={`identifier${ident.dbIdentifierId}`}
                              value={ident.identifier}
                              onChange={(e) => this.onEditIdentifier(e, ident)}
                            />
                            <div className="input-group-append">
                              <button tabIndex={-1} className='btn btn-danger' onClick={() => this.removeIdentifer(ident)}><i className='fa-solid fa-times' /></button>

                            </div>
                          </div>

                        </div>

                    ))}
                    </div>
                    </div>
                      </div>
                      <button className='btn btn-sm btn-success' onClick={this.addIdClick}>Add Identifier</button>
                    </div>

                  <div>

                    <div className='mt-4'>
                      <h5>Default Values:</h5>
                      <div>
                    <div className="row ms-2">
                      <div className="col-6 mb-2">
                  {this.state.currentDefault.defaultValues.map((dv) => (
                    dv.isDeleted !== true &&
                      <div key={dv.dbDefaultValueId} >

                        <div className="row mb-2">
                          <div className='col-6'>
                          <AutoComplete
                              id={`acDefaultValueField${dv.dbDefaultValueId}`}
                              allowedValues={this.state.allFields}
                              value={dv.fieldId}
                              valueField='fieldId'
                              displayField='name'
                              onChange={(e) => this.selectDefaultValueField(e, dv)}
                            //setFocus={this.setCurrentRoute}
                          />
                          </div>
                          <div className='col-6'>
                          <div className='input-group'>

                          <input type="text" className="form-control"
                            autoComplete='off'
                            value={dv.defaultValue}
                            onChange={(e) => this.onEditDefaultValue(e, dv)}
                          />
                          <div className="input-group-append">
                            <button tabIndex={-1} className='btn btn-danger' onClick={() => this.removeDefaultValue(dv)}><i className='fa-solid fa-times' /></button>

                          </div>
                          </div>
                          </div>
                        </div>

                      </div>

                  ))}
                  </div>
                  </div>
                  <button className='btn btn-sm btn-success' onClick={this.addDefaultValueClick}>Add Default Value</button>
                  </div>
                    </div>
                  </div>

                  </div>
                }

                </div>
              </div>
                {!this.state.deleteConfirm && <div>
                  {!this.state.newMode &&
                  <div>
                    {this.state.isDirty &&
                      <span className='float-start'>
                        <button className='btn btn-success mt-2 me-2' onClick={() => this.update(false)}>Save</button>
                        <button className='btn btn-success mt-2 me-2' onClick={() => this.update(true)}>Save and Add New</button>
                        <button className='btn btn-success mt-2' onClick={() => this.saveAs()}>Save as..</button>
                      </span>
                    }
                    <span className='float-end'><button className='btn btn-danger mt-2' onClick={this.showDeleteConfirm}>Delete Default</button></span>
                  </div>
                  }
                </div>
                }
                {this.state.deleteConfirm &&
                <div className='alert alert-danger mt-2'>
                  This will delete the default and any of its configurations.  Do you want to continue?
                  <button className='btn btn-danger ms-2' onClick={this.deleteDefault}>Delete</button>
                  <button className='btn btn-secondary ms-2' onClick={this.cancelDelete}>Cancel</button>
                </div>
                }



            </div>
          )}
        </div>
        {this.state.showSaveAs &&
          <div className='td-dialogue-container'>
            <div className='td-dialogue card' style={{ width: '450px' }}>
              <div className='card-header'>
                  Save Default As
                  <button
                    type='button'
                    className='btn-close'
                    onClick={this.cancelSaveAs}
                  />
                </div>
                <div
                  className='card-body'
                  style={{ height: '200px', padding: '12px', overflow: 'auto' }}
                >
                  <label className='form-label'>New Default Name:</label>
                  <input
                    type='text'
                    className='form-control'
                    placeholder='Default Name'
                    value={this.state.saveAsName}
                    onChange={this.editSaveAsName}
                  ></input>
                  <button disabled={this.state.showSaveAsButton ? false : true} className='btn btn-success mt-2' onClick={() => this.saveAsUpdate()}>Save</button>
                </div>
            </div>
          </div>
        }
        <Link
          id='loadDefaultLink'
          to={`/Admin/Defaults/${this.state.gotoDefault}`}
          style={{ display: 'none' }}
        >
          HiddenLink
        </Link>
        <Link
          id='defaultHome'
          to={`/Admin/Defaults`}
          style={{ display: 'none' }}
        >
          HiddenLink
        </Link>

      </div>
    );
  }
}

export default DefaultView;
